import { useMemo } from 'react'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import useBedbankSelectedDatesRates from 'hooks/useBedbankSelectedDatesRates'
import { take } from 'lib/array/arrayUtils'
import { getBedbankPackageCapacity } from 'lib/offer/bedbankCapacityUtils'
import getBedbankCardAmenities from 'lib/offer/getBedbankCardAmenities'
import getBedbankPricedPackage from 'lib/offer/getBedbankPricedPackage'
import OfferCardCapacityItems, { OfferCardCapacityGrid } from './OfferCardCapacityItems'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary | App.BedbankOfferWithRate
  selectedDatesAndRoomsFilter?: App.OfferListFilters
  totalInclusions?: number
}

function BedbankCardInclusions(props: Props) {
  const {
    offer,
    selectedDatesAndRoomsFilter,
    totalInclusions = 4,
  } = props

  const [{ hotelOnlyRates }] = useBedbankSelectedDatesRates(offer.id, selectedDatesAndRoomsFilter)
  const pricedRate = hotelOnlyRates[0]
  const capacity = useMemo(() => getBedbankPackageCapacity(getBedbankPricedPackage(offer, pricedRate)), [offer, pricedRate])

  const shownAmenities = useMemo(
    () => take(getBedbankCardAmenities(offer.popularFacilities), totalInclusions - 3),
    [offer.popularFacilities, totalInclusions],
  )

  if (!capacity && !shownAmenities.length) return null

  return <OfferCardCapacityGrid data-testid="bedbank-card-inclusions">
    {capacity && <OfferCardCapacityItems guests={capacity.guests} bedrooms={capacity.bedrooms} bathrooms={capacity.bathrooms} />}
    {shownAmenities.map((amenity) => <OfferInclusionItem
      key={amenity.id}
      inclusion={amenity}
    />)}
  </OfferCardCapacityGrid>
}

export default BedbankCardInclusions
